// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"3e9dd0fe","3742":"bd8661cf","5784":"7c8d6543","8448":"893e0b18","9596":"f6093be9"}[chunkId] + ".chunk.css";
};